import type { ContentElementFaqsProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: '',
  faqRoot:
    'grid gap-y-4 border-y border-gray-650/25 bg-white px-8 py-12 text-gray-700 shadow-card-sm md:px-28 md:py-14',
  faqItem: 'cursor-pointer select-none border-y-0.5 border-gray-650/25 py-2.5',
  heading: 'heading-3',
  faqButtonStyle: 'text-left',
  faqQuestion: 'font-bold pt-2 stroke-black',
  faqQuestionButtonStyle: 'flex justify-between w-full',
  faqAnswer: 'body-base empty:pt-0 pt-2',
  faqAnswerText: '',
} as ContentElementFaqsProps['classProps'];

export default classProps;
